
import { useEffect } from "react";
import { useProfileManagement } from "@/hooks/useProfileManagement";
import { ProfileFormContainer } from "@/components/profile/ProfileFormContainer";
import { Loader2 } from "lucide-react";

const ProfilePage = () => {
  const {
    profile,
    loading,
    saving,
    currentPassword,
    newPassword,
    confirmPassword,
    setProfile,
    setCurrentPassword,
    setNewPassword,
    setConfirmPassword,
    fetchProfile,
    handleProfileUpdate,
  } = useProfileManagement();

  useEffect(() => {
    fetchProfile();
  }, []);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center pb-20 md:pb-0">
        <Loader2 className="h-8 w-8 animate-spin text-[#2F80ED]" />
      </div>
    );
  }

  if (!profile) return null;

  return (
    <div className="min-h-screen bg-white pb-20 md:pb-0" style={{ fontFamily: 'Newsreader, "Noto Sans", sans-serif' }}>
      <div className="px-4 md:px-10 lg:px-40 flex flex-1 justify-center py-5">
        <div className="flex flex-col max-w-[960px] flex-1">
          <ProfileFormContainer
            profile={profile}
            saving={saving}
            currentPassword={currentPassword}
            newPassword={newPassword}
            confirmPassword={confirmPassword}
            onProfileChange={setProfile}
            onCurrentPasswordChange={setCurrentPassword}
            onNewPasswordChange={setNewPassword}
            onConfirmPasswordChange={setConfirmPassword}
            onSubmit={handleProfileUpdate}
            onUpdate={fetchProfile}
          />
        </div>
      </div>
    </div>
  );
};

export default ProfilePage;
